import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
  cardFormControl: {
    width: '100%',
  },
  customSwitch: {},
  customCheckbox: {
    padding: 0,
  },
  customLabel: {
    width: '100%',
    margin: 0,
  },
  inlineLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: 16,
      color: '#475569',
      fontWeight: 'bold',
    },
  },
  inlineIcon: {
    color: '#AAB8C7',
    fontSize: 24,
  },
  inlineIconChecked: {
    color: theme.palette.primary.main,
    fontSize: 24,
  },
  cardLabel: {
    alignItems: 'flex-start',
    backgroundColor: '#F3F5F8',
    border: '1px solid #D6DFEA',
    borderRadius: 14,
    padding: '22px 26px',
    '& .MuiCheckbox-root': {
      marginRight: 10,
      marginTop: 2,
      padding: 0,
    },
    '& .MuiFormControlLabel-label': {
      color: '#3C4D65',
      fontSize: 17,
      fontWeight: 700,
      lineHeight: 1.45,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 15,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
      },
    },
  },
  cardLabelError: {
    borderColor: theme.palette.error.main,
  },
  cardIcon: {
    color: '#B7C4D2',
    fontSize: 26,
  },
  cardIconChecked: {
    color: theme.palette.primary.main,
    fontSize: 26,
  },
  cardHelperText: {
    marginLeft: 0,
    marginTop: theme.spacing(1),
  },
}));
